<template>
  <div class="skeleton-card shimmer"></div>
</template>


<style scoped>
.skeleton-card {
  width: 100%;
  height: 100px;
  border-radius: 16px;
  margin-bottom: 20px;
  background: #e0e0e0;
}

[data-theme="dark"] .skeleton-card {
  background: #484848;
}

.shimmer {
  background: linear-gradient(
    to right,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite linear;
}

[data-theme="dark"] .shimmer {
  background: linear-gradient(
    to right,
    #393939 0%,
    #2b2b2b 50%,
    #3e3e3e 100%
  );
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>